export { default } from './CarouselDotPager'
